export default {"src":"/_next/static/media/noise.d6186dcb.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};